module.exports = __webpack_public_path__ + "static/media/pound-icon.ea775a60.svg";